import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaContratos from '../../components/contratos/listar';


function ListaContratosScreen() {
    return (
        <Fragment>
            <Head titulo="Todos contratos do Município de Macuco" />
            <Header />
            <Container>
                <ListaContratos />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosScreen;